import React from 'react';
import './VolumeWheelItem.scss';
import ProductPoster from '../../../KodanshaUIKit/ProductPoster/ProductPoster';
import { Link } from '../../../../Devon/Components/InkyLink';
import { Product } from '../../../../Models/Product';
import Log from '../../../Services/Logger';

interface Props {
    volume: Product;
    currentVolume: boolean;
    number?: number;
}

const VolumeWheelItem = ({ volume, currentVolume, number }: Props) => {
    Log.debug('props22volume', volume);
    if (!volume) {
        return null;
    }

    return (
        <Link to={'/product/' + (volume.readableUrl ?? volume.id)}
              className={`volume-wheel-item-wrapper ${currentVolume && 'volume-wheel-item--current-wrapper'}`}>
            <ProductPoster
                preloadImage={false}
                src={volume.thumbnails[0]?.url}
                alt={'poster for ' + volume.name}
                s={{width: 102}}
                m={{width: 125}}
                l={{width: 161}}
                xl={{width: 83}}
            />
            <span className={`volume-number ${currentVolume && 'current-volume-number'}`}>
                {volume.volumeNumber ?? number ?? volume.chapterNumber ?? volume.name}
            </span>
            {currentVolume && <span className='current'>You're here!</span>}
        </Link>
    );
};

export default VolumeWheelItem;
